import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function TooltipTitle(props) {
  const {
    toolAccess
  } = props;
  const testId = 'ui-tool-access-tooltip-content';
  if (toolAccess.loading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      size: "small"
    });
  }
  if (toolAccess.error) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "toolAccess.error.linkBody"
    });
  }
  if (toolAccess.request) {
    const {
      approver
    } = toolAccess.request;
    return /*#__PURE__*/_jsxs("div", {
      "data-test-id": testId,
      children: [/*#__PURE__*/_jsx("p", {
        "data-test-id": `${testId}-pending`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "toolAccess.requestPendingTextA",
          options: Object.assign({}, approver)
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "toolAccess.requestPendingTextB"
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlockEnd: "100",
      as: "div",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "toolAccess.tooltip.noAccess"
      })
    }), /*#__PURE__*/_jsx(Link, {
      "data-test-id": "ui-tool-access-tooltip-modal-link",
      onClick: toolAccess.openModal,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "toolAccess.requestPermissionUpdate"
      })
    })]
  });
}
export default TooltipTitle;